var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.ident}},[(_vm.bar.value < 100)?_c('b-progress',{key:_vm.bar.variant,attrs:{"value":_vm.bar.value,"variant":_vm.bar.variant,"show-progress":""}}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }